<template>
  <div class="text-xl" :class="{ 'filter-active': infoOpen }">
    <Projects />
    <Title />
    <HeroText />
    <div
      class="backdrop fixed left-0 top-0 w-screen h-screen z-20 pointer-events-none"
    />
    <Info />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Info from "./Info";
import Projects from "./Projects";
import Title from "./Title";
import HeroText from "./HeroText";

export default {
  name: "Home",

  components: {
    Info,
    Projects,
    Title,
    HeroText
  },

  computed: mapState(["infoOpen"])
};
</script>
